<template>
  <div class="carousel carousel-slider">
      <v-carousel :show-arrows="false" hide-delimiters cycle hide-delimiter-background show-arrows-on-hover :interval="speed">
        <v-carousel-item class="carousel-item" v-for="slider in sliders">
          <div class="container">
            <h2>{{slider.transTitle}}</h2>
          </div>
          <img :src="baseUrl+slider.transFullFilesDirectory">
        </v-carousel-item>
      </v-carousel>
  </div>
</template>
<script>

  export default {
    props: {
      sliders: Array | Object,
      speed: Number
    },
    data () {
      return {
        baseUrl: process.env.VUE_APP_BACK_URL
      }
    }
  }
</script>
